import { addLocaleData } from "react-intl";
import pt from "react-intl/locale-data/pt";

/*
Before adding new keys here, add a key mapping in the keys.json file in this directory for
intl and abstraction purposes.
*/
const messages = {
  // PRESCRIBER DASHBOARD
  platform_fees: "Taxas da Plataforma",
  prices: "Preços",
  onboarding: "Onboarding",
  onboarding_welcome: "Bem-vindo ao seu Painel de Controlo do Sayn!",
  onboarding_welcome_message:
    "Para poder enviar Prescrições, por favor complete o seu registo no Stripe.",
  onboarding_welcome_button: "Registar no Stripe",
  onboarding_success: "Onboarding concluído com sucesso!",
  onboarding_success_title: "Onboarding concluído",
  onboarding_success_subtitle:
    "A sua conta Stripe está ativa e pronta para receber pagamentos.",
  onboarding_success_message:
    "Antes de enviar Prescrições aceda à página de Pagamentos. Aí poderá escolher a(s) sua(s) taxa(s).",
  onboarding_waiting_for_fees:
    "O Stripe está ativo. Aguarde até que o proprietário defina as taxas na página de Pagamentos.",
  onboarding_reload_message:
    "Agora está pronto para enviar Prescrições. Por favor, recarregue a página.",
  onboarding_no_account: "Nenhuma conta Stripe encontrada para este utilizador.",
  onboarding_redirecting: "A redirecionar para o Stripe...",
  onboarding_error:
    "Ocorreu um erro durante o onboarding. Por favor tente novamente mais tarde ou contacte o suporte.",
  onboarding_error_title: "Erro!",
  onboarding_redirected: "Redirecionado para o Stripe.",
  onboarding_need_info: "Informações adicionais necessárias",
  onboarding_need_info_message:
    "O Stripe requer alguns dados adicionais para manter seus pagamentos ativos. Atualize seus dados para continuar a enviar Prescrições.",
  onboarding_need_info_button: "Atualizar dados no Stripe",
  go_to_payments: "Ir para a página de Pagamentos",
  stripe_registered: "Registada no Stripe",
  prescriber_stripe_account_message:
    "Faça login na sua conta Stripe para verificar o seu saldo e transações e alterar as suas configurações como e-mail, número de telefone e dados bancários:",
  go_to_stripe: "Ir para o Stripe",
  my_stripe_account: "A minha conta Stripe",
  allowed_invitations: "Convites Permitidos",
  bundle: "Pacote",
  value: "Valor",
  sayn_fee: "Taxa SAYN",
  standard_value: "Valor cobrado pelo SAYN",
  your_fee: "A sua taxa",
  custom_value: "Montante que irá receber",
  final_price: "Preço final",
  customer_value: "Valor cobrado ao cliente",
  select_single_reports: "Selecionar o relatório individual",
  bundle_reports: "Conjunto (Sayn 1 e Sayn 2)",
  best_price: "Melhor preço",
  select_one_report: "Selecionar apenas um relatório",
  select_one_report_description:
    "Tenha em atenção os relatórios Sayn 1 e Sayn 2 são ambos necessários para beneficiar de uma leitura global.",
  payments: "Pagamentos",
  prescriber_price_save_alert: "Valores de pagamento guardados com sucesso!",
  notice: "Aviso",
  payments_currency_conversion_notice:
    "Se um cliente pagar numa moeda diferente do Euro (€), o Stripe aplicará uma taxa de conversão.",
  report_edit_sensorial_rhythm: "Ritmo Sensorial",
  report_edit_personal: "Pessoal",
  report_edit_individual: "Individual",
  report_edit_social: "Social",
  report_edit_organizational: "Organizacional",
  click_select_image: " Clique aqui para selectionar Imagem",
  report_structure_saved: "Relatório guardado com sucesso!",
  page_content: "Conteúdo da página",
  report_edit_personalIdentity: "Identidade pessoal",
  report_edit_internalPerception: "Percepção interna",
  report_edit_informationProcessing: "Processamento de informação",
  report_edit_passingOfHabits: "Alteração de hábitos",
  report_edit_functionalEfficiency: "Eficiência funcional",
  report_edit_other_graphs: "Outros gráficos",
  reactivity: "Reatividade",
  "429_title": "Limite de Pedidos atingido",
  "429_message": "Fez demasiados pedidos. Por favor, tente novamente mais tarde.",
  invitation_remote: "Convite Pré-pago",
  invitation_remote_self: "Convite Pré-pago (para si próprio)",
  remote_invite_message: "A quem pretende enviar o convite?",
  remote_invite_option_1_title: "Para Mim",
  remote_invite_option_1_subtitle: "Acesso direto",
  remote_invite_option_2_title: "Para Outra Pessoa",
  remote_invite_option_2_subtitle: "Presente enviado por email",
  remote_invite_details_1: "Os seus dados",
  remote_invite_placeholder_self_name: "Introduza o seu nome completo",
  remote_invite_placeholder_self_first_name: "Introduza o seu nome",
  remote_invite_placeholder_self_surname: "Introduza o seu apelido",
  remote_invite_placeholder_self_email: "Introduza o seu email",
  remote_invite_details_2: "Pessoa convidada",
  remote_invite_placeholder_first_name: "Introduza o nome da pessoa convidada",
  remote_invite_placeholder_surname: "Introduza o apelido da pessoa convidada",
  remote_invite_placeholder_email: "Introduza o email da pessoa convidada",
  direct_access: "Acesso direto",
  remote_invite_self_subtitle: "Para Mim",
  remote_invite_subtitle: "Para Outra Pessoa",
  remote_invite_success_title: "Convite realizado com sucesso",
  remote_invite_success_subtitle:
    "A pessoa convidada irá receber um email para continuar o processo. Obrigado.",
  remote_invite_self_success_title: "Pedido realizado com sucesso",
  remote_invite_self_success_subtitle:
    "Irá receber um email para continuar o processo. Obrigado.",
  invite_blocked_title: "Convite bloqueado",
  invite_blocked_answered_subtitle:
    "Este paciente respondeu a um Questionário em {date}. Por favor aguarde até {expiry} antes de enviar uma nova prescrição.",
  invite_blocked_pending_subtitle:
    'Este paciente tem um Questionário pendente desde {date}. Por favor aguarde até {expiry} antes de enviar uma nova prescrição ou procure a prescrição pendente no seu Monitor e clique em "{resend_button}".',
  remote_invite_blocked_title: "Convite bloqueado",
  remote_invite_blocked_answered_subtitle:
    "Respondeu a um Questionário em {date}. Por favor aguarde até {expiry} antes de requisitar um novo convite.",
  remote_invite_other_blocked_answered_subtitle:
    "{name} respondeu a um Questionário em {date}. Por favor aguarde até {expiry} antes de enviar um novo convite.",
  remote_invite_blocked_pending_subtitle:
    "Tem um Questionário pendente desde {date}. Por favor confira o seu email ou aguarde até {expiry} antes de requisitar um novo convite.",
  remote_invite_other_blocked_pending_subtitle:
    "{name} tem um Questionário pendente desde {date}. Por favor aguarde até {expiry} antes de enviar outro convite.",
  only: "Apenas",
  finish: "Concluir",
  sayn1_description:
    "Avalia as respostas do seu corpo aos estímulos externos (ambiente, relações, trabalho, etc.) e a sua capacidade de equilíbrio.",
  sayn2_description:
    "Avalia as funções sensoriais internas, a gestão de recursos energéticos e a capacidade de recuperação.",
  both_reports_description: "Ambos os Relatórios (Sayn 1 e 2)",
  //  PRESCRIBER DASHBOARD
  this_language: "português",
  unsaved_changes: "Alterações não guardadas",
  unsaved_changes_message:
    "Tem a certeza que deseja sair? As alterações não guardadas serão perdidas.",
  pdf_load_error: "Erro ao carregar PDF",
  stats_info: "Este valor corresponde ao aumento relativamente ao mês anterior",
  no_results_found: "Nenhum resultado encontrado",
  not_started: "Não Iniciado",
  resend_prescription: "Reenviar Prescrição",
  prescription: "Prescrição",
  send_results_after_completion:
    "Enviar os resultados ao paciente por e-mail após conclusão",
  report_unavailable: "Este relatório não está disponível",
  report_unavailable_description:
    "O paciente pode desbloqueá-lo seguindo o link disponível no e-mail com os Relatórios",
  send_invite_text: "Deseja reenviar este convite?",
  resend: "Reenviar",
  invite_success: "Convite enviado com sucesso!",
  send_results: "Enviar Resultados",
  send_results_text: "Deseja enviar os Resultados ao paciente?",
  send_results_success: "Resultados enviados com sucesso!",
  send_reports: "Enviar Relatórios",
  view_result: "Ver Relatório",
  change_chart: "Mudar Gráfico",
  choose_report: "Escolher Relatório",
  choose_reports: "Escolher Relatórios",
  report_not_requested:
    "Este relatório não foi solicitado. Pode aceder ao mesmo por {price}€",
  english_language: "Inglês",
  portuguese_language: "Português",
  french_language: "Francês",
  back: "Retroceder",
  error_title: "Ocorreu um erro",
  error_description:
    "Por favor, tente de novo. Se o problema persistir, contacte o serviço de assistência.",
  confirmed: "Confirmada",
  email_confirmed_close_tab: "O seu e-mail foi confirmado! Pode fechar este separador.",
  email_already_confirmed: "O seu e-mail já está confirmado. Pode iniciar sessão agora.",
  account_deletion_page_title: "Eliminar Conta",
  account_deletion_intro: "Reveja os detalhes da sua conta antes de continuar.",
  account_deletion_warning:
    "Esta ação é permanente e não pode ser revertida. Depois de eliminada, perderá o acesso a todos os seus Relatórios.",
  account_deletion_button: "Eliminar a Minha Conta",
  account_deletion_confirm_title: "Eliminar a sua conta?",
  account_deletion_confirm_content:
    "Isto irá eliminar permanentemente a sua conta e perderá o acesso a todos os seus Relatórios. Esta ação não pode ser revertida.",
  account_deletion_confirm_ok: "Sim, eliminar a minha conta",
  account_deletion_confirm_cancel: "Cancelar",
  account_deletion_success: "A sua conta foi eliminada. Já pode fechar esta janela.",
  account_deletion_error:
    "Ocorreu um erro ao eliminar a sua conta. Tente novamente ou contacte o suporte.",
  account_deletion_loading: "A carregar a sua conta...",
  account_deleted_label: "Conta eliminada",
  questionnaires: "Questionários",
  monitor: "Monitor",
  company_monitor: "Monitor {name}",
  subscription: "Subscrição",
  pd_completed: "Completa",
  failed: "Falhou",
  select_reports: "Selecionar Relatórios",
  choose_option: "Escolha uma opção",
  patient_paid: "Pago pelo Paciente",
  patient_paid_description: "O paciente receberá um email para proceder ao pagamento.",
  pre_paid: "Pré-paga",
  pre_paid_description: "O serviço será feito agora.",
  both_reports: "Ambos os Relatórios",
  reports_and_payment: "Relatórios e pagamento",
  prescription_successful: "A Análise SAYN foi prescrita com sucesso.",
  patient_will_receive_email:
    "Bom trabalho. O seu / a sua paciente irá receber um email com todos os passos para submeter a sua análise.\nPara acompanhar o processo, consulte o Panorama.",
  completed_analysis: "Análises feitas",
  prescriptions_sent: "Prescrições Enviadas",
  total_patients: "Total de Pacientes",
  overview: "Panorama",
  log_out: "Sair",
  dashboard: "Painel de Controlo",
  backoffice: "Backoffice",
  my_profile: "O Meu Perfil",
  sayn_description:
    "A Análise SAYN é o primeiro recurso de diagnóstico capaz de descodificar a energia orgânica dos seus pacientes, para ajudar a aplicar e adaptar qualquer tratamento, promovendo, assim, um cuidado eficiente e os melhores resultados possíveis.",
  assistance_email: "Se precisar de assistência, por favor envie um e-mail para {email}",
  need_help: "Precisa de ajuda?",
  check_documentation: "Consulte o nosso guia para encontrar as respostas que procura",
  documentation: "Guia Sayn",
  view_results: "Resultados",
  completion: "Conclusão",
  prescription_date: "Prescrição feita a",
  prescribe_analysis: "Prescrever Análise",
  waiting: "A aguardar",
  pd_add_observations: "Observações",
  pd_save: "Guardar",
  search_patient: "Procurar Paciente",
  search_patient_or_prescriber: "Procurar Paciente/Prescritor",
  search_team_member: "Procurar membro da equipa",
  rows_per_page: "Linhas por Página",
  patients: "Pacientes",
  close: "Fechar",
  close_dialog: "Fechar janela",
  refresh_monitor: "Atualizar monitor",
  no_prescriptions_yet:
    'Ainda não tem prescrições. Clique em "{prescribe_button}" para começar a enviar.',
  prepayment_draft_leave_warning:
    "O pagamento não foi concluído. Sair irá descartar este rascunho de prescrição.",
  success: "Sucesso",
  reload_page: "Atualizar a página",
  email: "Email",
  patient_information: "Informação do/a paciente",
  new_patient: "Novo Paciente",
  setup_patient_information: "Preencher informação",
  existing_patient: "Paciente Existente",
  select_from_patients: "Selecione a partir da sua lista de pacientes",
  complete_information: "Complete as informações",
  invite_placeholder_first_name: "Insira o nome do paciente",
  invite_placeholder_last_name: "Insira o apelido do paciente",
  invite_placeholder_email: "Insira o e-mail do paciente",
  enter_notes:
    "Se deseja adicionar observações ao seu / à sua paciente, por favor faça-o aqui",
  sd_next: "Prosseguir",
  // OTHER
  link_in_button_error: "Não é possível inserir um link dentro de um botão",
  allow_prescriber: "Permitir que o seu prescritor veja este relatório",
  report_payment_message:
    "Pagamento efetuado com sucesso! O relatório será enviado para o seu e-mail.",
  already_paid: "O pagamento já foi efetuado.",
  both: "Ambos",
  paid: "Pago",
  not_paid: "Não Pago",
  reports_paid: "Relatórios Pagos",
  report_link: "Relatório (c/ link de pagamento)",
  report_both: "Relatório(s)",
  email_change_confirmation: "Confirmação de alteração de email",
  email_change_pending_message:
    "Foi enviado um email de confirmação para {email}. O email de início de sessão só muda depois de confirmar.",
  email_change_pending_notice: "A aguardar confirmação de {email}.",
  email_confirmation_app: "Confirmação de email para a aplicação",
  email_address_changed: "Endereço de email alterado",
  questionnaire_message: "Mensagem inicial do questionário",
  image_delete: "Tem a certeza que quer eliminar esta imagem?",
  image_delete_error:
    "Esta imagem não pode ser eliminada porque está a ser utilizada noutro local ({entity}). Remova a imagem deste local para a poder eliminar.",
  delete_success: "{entity} eliminada com sucesso!",
  question_image: "Pergunta",
  insert_url:
    "Introduza o URL completo do link (incluindo http:// ou https://):",
  download: "Descarregar",
  signup: "Registar",
  sign_up_prescriber: "Registo de Prescritor",
  owner_assignment: "Atribuição de Proprietário",
  owner_signup: "Registo de Proprietário",
  preview: "Pré-visualizar",
  gallery: "Galeria",
  gallery_search_by_name: "Pesquisar por nome",
  edit_image_name: "Editar nome da imagem",
  buttons: "Botões",
  variables: "Variáveis",
  links: "Links",
  enlarge: "Ampliar",
  add_image: "Adicionar Imagem",
  edit_text: "Editar Texto",
  custom_texts: "Textos Personalizados",
  seasonal_reminder: "Notificação Sazonal",
  prescriber_message: "Mensagem ao Prescritor",
  template_error: "Todas as Variáveis e Botões da lista devem ser utilizados",
  email_template_saved: "Modelo de Email guardado",
  email_changed: "Alteração de email",
  push_notifications: "Notificações push",
  new_invitation: "Novo Convite",
  new_report: "Novo Relatório",
  push_notification_saved: "Notificação push guardada!",
  custom_text_saved: "Texto Personalizado guardado",
  email_subject: "Assunto do Email",
  template: "Modelo",
  edit_template: "Editar Modelo",
  email_templates: "Modelos de Email",
  existing_pacient: "Paciente existente",
  new_pacient: "Novo Paciente",
  not_send: "Não enviar",
  user_name: "Nome",
  user_surname: "Apelido",
  job: "Profissão",
  birth: "Nascimento",
  portuguese: "Portuguesa",
  french: "Francesa",
  error_prepay_remote:
    "Ocorreu um erro ao processar o seu pedido. Por favor contacte-nos diretamente.",
  default_questionnaire_price: "Preço base para SAYN1 + SAYN2 (em cêntimos)",
  default_sayn1_price: "Preço base para SAYN1 (em cêntimos)",
  default_sayn2_price: "Preço base para SAYN2 (em cêntimos)",
  post_questionnaire_delay: "Tempo de espera após Questionário (em horas)",
  seasonal_reminder_range: "Intervalo da Notificação Sazonal (em dias)",
  seasonal_reminder_unsubscribed:
    "Foi cancelada a sua subscrição. Irá deixar de receber notificações sazonais a partir de agora.",
  token_expiry: "Duração da sessão após login (HH:mm)",
  token_expiry_invalid: "Use HH:mm (as horas podem ultrapassar 23, p.ex. 48:00)",
  totp: "Código do autenticador",
  totp_help: "Abra a sua aplicação autenticadora e introduza o código de 6 dígitos desta conta.",
  session_expired: "A sua sessão expirou, inicie sessão novamente.",
  session_expired_login: "Iniciar sessão",
  enroll_totp_help:
    "Leia este código QR com a sua aplicação autenticadora e introduza o código de 6 dígitos.",
  enroll_totp_manual: "Não consegue ler o código? Introduza esta chave:",
  enroll_totp_qr_alt: "Código QR do autenticador",
  invalid_totp: "Código do autenticador inválido",
  totp_challenge_timeout:
    "O desafio do autenticador expirou. Introduza novamente o email e a palavra-passe.",
  keep_me_logged_in: "Manter-me ligado durante 90 dias",
  mfa_required: "É necessária a verificação do autenticador",
  invalid_firebase_token: "Sessão inválida ou expirada. Tente novamente.",
  invalid_role: "Esta conta não pode iniciar sessão no Backoffice",
  MFA_REQUIRED: "É necessária a verificação do autenticador",
  INVALID_FIREBASE_TOKEN: "Sessão inválida ou expirada. Tente novamente.",
  INVALID_ROLE: "Esta conta não pode iniciar sessão no Backoffice",
  backoffice_values: "Valores Editáveis",
  max_observation_size: "O tamanho máximo da observação é de {max} caracteres",
  first_graph_observations_unavailable:
    "Não é possível adicionar observações para o primeiro gráfico. Selecione outro gráfico para continuar.",
  observations_saved: "Observações guardadas!",
  values_saved: "Valores guardados!",
  block_report: "Impedir envio do Relatório",
  block_prescriber: "Suspender",
  unblock_prescriber: "Reativar",
  block_company: "Suspender",
  unblock_company: "Reativar",
  blocked: "BLOQUEADA",
  prescriber_access_denied_title: "Acesso negado",
  prescriber_access_denied_message:
    "A sua conta foi suspensa por motivos internos. Contacte o proprietário da sua equipa caso considere que existe um problema.",
  owner_access_denied_message:
    "A sua conta foi suspensa por motivos internos. Contacte-nos caso considere que existe um problema.",
  prescriber_no_company_message:
    "Tem de estar associado a uma clínica/empresa para aceder à plataforma. Contacte-nos caso considere que existe um problema.",
  NO_COMPANY:
    "Tem de estar associado a uma clínica/empresa para aceder à plataforma.",
  add_observations: "Adicionar Observações",
  report_sent: "Relatório enviado",
  sent: "Enviado",
  not_sent: "Não enviado",
  go_back: "Voltar",
  go_to_home: "Ir para a página inicial",
  observations: "Observações",
  observations_recommendations: "Notas / Recomendações",
  all_rights_reserved: "Todos os direitos reservados",
  amplitude: "Amplitude",
  next: "Avançar",
  loading: "A carregar",
  landing_where_answer: "Onde pretende responder ao Questionário?",
  landing_open_in_app: "Abrir na app Sayn",
  landing_continue_in_browser: "Continuar no browser",
  landing_loading: "A carregar…",
  landing_redirecting: "A redirecionar...",
  search: "Procurar",
  reset: "Repor",
  required: "Obrigatório",
  start: "Início",
  pacient: "Paciente",
  prescriber: "Prescritor",
  no_prescriber: "sem prescritor",
  notes: "Notas",
  general_definitions: "Definições Gerais",
  help: "Ajuda",
  privacy_policy: "Politica de Privacidade",
  copyright: "copyright © 2019 Sensor",
  date: "Data",
  cancel: "Cancelar",
  save: "Guardar",
  other: "Outro",
  create: "Criar",
  upload: "Carregar",
  image_upload_max_size: "A imagem deve ter no máximo 5 MB.",
  image_upload_invalid_type: "Só pode carregar ficheiros JPG, PNG ou GIF.",
  IMAGE_FILE_TOO_LARGE: "A imagem deve ter no máximo 5 MB.",
  edit: "Editar",
  are_you_sure: "Tem a certeza?",
  yes: "Sim",
  no: "Não",
  price: "Preço",
  total_price: "Preço Total",
  language: "Idioma",
  created_at: "Criado em",
  updated_at: "Atualizado em",
  read_at: "Lido em",
  title: "Título",
  users: "Utilizadores",
  message: "Mensagem",
  cta_questionnaire: "Responder ao Questionário",
  submit: "Submeter",
  view: "Visualizar",
  delete: "Eliminar",
  delete_image: "Eliminar imagem",
  ACTIVE: "Ativo",
  DISABLED: "Desativado",
  created_by: "Criado por",
  actions: "Acções",
  answers: "Respostas",
  completed: "Completo",
  not_completed: "Incompleto",
  questionnaire: "Questionário",
  questions: "Perguntas",
  open: "Aberta",
  multiple: "Multipla",
  text: "Texto",
  closed: "Fechada",
  close_window: "Pode fechar esta janela agora.",
  single: "Única",
  usersHeader: "Utilizadores",
  history: "Histórico",
  answerQuestionnaire: "Responder Questionário",
  status: "Estado",
  items: "Itens",
  user: "Utilizador",
  up: "Para cima",
  down: "Para baixo",
  ok: "Sim",
  criteria: "Critérios",
  criteriaUsage: "Uso de Critérios",
  metaSkill: "Meta Habilidades",
  principle: "Princípios",
  code: "Código",
  name: "Nome",
  question: "Pergunta",
  answer: "Resposta",
  all: "Todos",
  meta_competences: "Meta Competências",
  confirm: "Confirmar",
  return: "Voltar",
  invites: "Convites",
  invite: "Convidar",
  send: "Enviar",
  elements: "Elementos",
  attributes: "Atributos",
  energy_flow: "Fluxo de Energia",
  sending: "A Enviar",
  feelings: "Sentimentos",
  organs: "Órgãos",
  meta_data: "Meta Dados",
  metadata_bank: "Banco de Meta Dados",
  output_metadata: "Meta Dados do Output",
  input_metadata: "Meta Dados do Input",
  outputs: "Outputs",
  inputs: "Inputs",
  image_metadata: "Meta Dados da Imagem",
  image: "Imagem",
  output_information: "Informação do Output",
  none: "Nenhum",
  add_input: "Adicionar Input",
  add_output: "Adicionar Output",
  input_name: "Nome dos Inputs",
  input_content: "Conteúdo do Input",
  type: "Tipo",
  output_content: "Conteúdo do Output",
  output_name: "Nome do Output",
  change_type: "Alterar tipo",
  input_information: "Informação do Input",
  dowload_excel_users: "Exportar para Excel",
  excel_users_title: "Lista_Utilizadores",
  printPDF: "Imprimir em PDF",
  element_attributes: "Atributos do Elemento",
  attributes_bank: "Banco de Atributos",
  sense: "Sentidos",
  duplicate: "Duplicar",
  natural_elements: "Elementos Naturais",
  add_natural_element: "Criar Novo Elemento Natural",
  create_new_natural_element: "Criar Novo Elemento Natural",
  edit_natural_element: "Editar Elemento Natural",
  add_season: "Criar Nova Estação",
  create_new_season: "Criar Nova Estação",
  edit_season: "Editar Estação",
  season: "Estação",
  add_character: "Criar Novo Carácter",
  create_new_character: "Criar Novo Carácter",
  edit_character: "Editar Carácter",
  character: "Caracteres",
  basic_settings: "Definições Básicas",
  security_settings: "Definições de Segurança",
  first_name: "Nome Próprio",
  last_name: "Apelido",
  birth_place: "Local de Nascimento",
  job_name: "Profissão",
  nationality: "Nacionalidade",
  gender: "Género",
  birth_date: "Data de Nascimento",
  old_password: "Password",
  new_password: "Escolha uma nova Palavra-passe",
  choose_password: "Escolha uma Palavra-passe",
  password: "Password",
  confirm_email: "Confirmar Email",
  confirm_password: "Confirmar Palavra-passe",
  change: "Alterar",
  profile: "Perfil de Utilizador",
  male: "Masculino",
  female: "Feminino",
  change_password: "Alterar Palavra-passe",
  invalid_password: "Palavra-passe Inválida",
  password_changed: "A sua palavra-passe foi alterada",
  required_password: "Por favor, introduza a palavra-passe",
  password_does_not_meet_requirements:
    "A palavra-passe deve conter pelo menos 6 caracteres, 1 caractere maiúsculo e 1 caractere numérico",
  match_password: "Palavras-passe diferentes",
  password_recovery: "Recuperação de palavra-passe",
  password_recovery_msg:
    "Foi enviado um email com um link para alterar a sua palavra-passe. Verifique a sua caixa de entrada.",
  match_email: "Emails diferentes",
  input_email: "Por favor, introduza o seu email",
  invalid_email: "Email inválido",
  profile_updated: "Perfil atualizado",
  profile_updated_message: "O seu perfil foi atualizado",
  creation_date: "Data do Registo",
  no_information: "Sem Informação",
  manage_question_criteria: "Gerir Critérios da Pergunta",
  logout: "Sair",
  login: "Fazer login",
  login_success: "Login efetuado com sucesso!",
  register: "Registar",
  register_success: "Registo efetuado com sucesso!",
  auth_questionnaire_msg:
    "Irá ser redireccionado para o Questionário. \nReceberá no seu e-mail um link, caso queira voltar mais tarde. \nClique OK para continuar.",
  new_notification: "Nova Notificação",
  send_notification_to: "Enviar Notificação Para",
  all_users: "Todos os Utilizadores",
  some_users: "Alguns Utilizadores",
  dynamic_keys: "Chaves dinâmicas",
  confirm_message_disable: "Gostaria de desactivar",
  confirm_message_enable: "Gostaria de activar",
  confirm_this_male: "este",
  confirm_this_female: "esta",
  enable: "activar",
  disable: "desactivar",
  answer_option: "Opção de resposta",
  text_answer_placeholder: "Escreva aqui a resposta",
  one_criteria: "critério",
  one_criteria_usage: "utilidade de critérios",
  one_meta_skill: "competência",
  one_principle: "princípio",
  resending_invitation: "Reenviar Convite",
  resending_invitation_to: "Reenviar convite para",
  to_fill_questionnaire: "para preencher o questionário",
  clipboard: "Copiar Código do Convite",
  save_changes: "Guardar as Alterações",
  discard_changes: "Descartar as Alterações",
  mobile_answer_component: "Componentes",
  one_mobile_answer_component: "Componente de Resposta Mobile",
  add_mobile_answer_component: "Criar Novo Componente de Resposta Mobile",
  create_new_mobile_answer_component: "Criar Novo Componente de Resposta Mobile",
  edit_mobile_answer_component: "Editar Componente de Resposta Mobile",
  disable_mobile_answer_component: "Desactivar Componente de Resposta Mobile",
  enable_mobile_answer_component: "Activar Componente de Resposta Mobile",
  general: "Geral",
  algorithm_values: "Valores do Algoritmo",
  skill_anchor: "Habilidades de Alavancagem",
  skill_compensated: "Habilidade de Compensação",
  skill_decompensated: "Habilidade de Descompensação",
  criteria_management: "Gestão de Critérios",
  free_in_app: "Grátis na APP",
  add_criteria: "Adicionar Novo Critério",
  edit_criteria: "Editar Critério",
  free: "Gratuito",
  initial_date: "Data de Inicio",
  expire_date: "Data de Fim",
  description: "Descrição",
  entities_assigned: "Entidades Atribuídas",
  entities: "Entidades",
  effect_type: "Tipo de Efeito",
  effect: "Efeitos",
  create_new_highlight_output: "Criar Novo Highlight Output",
  highlight_type: "Tipos de Destaque",
  create_new_highlight_type: "Criar Novo Tipo de Destaque",
  link_android: "Hiperligação Android",
  link_ios: "Hiperligação IOS",
  mobile_apps: "Aplicações Móveis",
  text_config: "Configuração de Texto",
  assign_entities: "Atribuir Entidades",
  disable_text_config: "Desactivar configuração de texto",
  enable_text_config: "Activar configuração de texto",
  env: "Variáveis de Ambiente",
  add_env: "Criar Nova Variável de Ambiente",
  daily_challenge: "Desafio Diário",
  number_of_inputs: "Número de Inputs",
  min_days_of_interval: "Mínimo dias de Intervalo",
  add_highlight_type: "Adicionar Tipo de Destaque",
  daily_challenge_saved: "Desafio Diário guardado",
  create_new_highlight_questionnaire: "Criar Novo Highlight - Questionário",
  create_new_highlight_question: "Criar Novo Highlight - Pergunta",
  edit_highlight_questionnaire: "Editar Highlight - Questionário",
  edit_highlight_question: "Editar Highlight - Pergunta",
  type_image: "IMAGEM",
  type_text: "TEXTO",
  edit_question: "Editar Pergunta",
  clean_filters: "Limpar Filtros",
  static_string: "Strings Estáticas",
  add_static_string: "Criar Nova String Estática",
  string_value: "Valor da String",
  add_feeling: "Criar Novo Sentimento",
  edit_feeling: "Editar Sentimento",
  add_organ: "Criar Novo Orgão",
  edit_organ: "Editar Orgão",
  input_translation: "Por favor, insira todas as traduções.",
  select_answer_type: "Por favor, seleccione o tipo de resposta.",
  set_criteria_as_free: "Definir Critério como gratuito",
  remove_criteria_as_free: "Remover Critério",
  confirm_set_free: "Gostaria de definir este critério como gratuito?",
  confirm_remove_free: "Gostaria de remover este Critério?",
  free_criterias: "Critérios Grátis",
  confirm_set_question_non_required:
    "Gostaria de definir esta pergunta como não-obrigatória ?",
  confirm_set_question_required: "Gostaria de definir esta pergunta como obrigatória ?",
  set_non_required: "Definir pergunta como não obrigatória",
  set_required: "Definir pergunta como obrigatória",
  duplicate_questionnaire: "O questionário foi duplicado",
  add: "Adicionar",
  update_questionnaire: "O questionário foi actualizado",
  add_new_app: "Adicionar Nova App",
  translate: "Traduzir",
  delete_general_output:
    "Este output não pode ser eliminado porque está a ser utilizado na APP",
  alternative_report: "Relatório alternativo",
  edit_static_string: "Editar Texto Estático",
  edit_rich_text: "Editar Texto Formatado",
  add_rich_text: "Criar Novo Texto Formatado",
  plain_text: "Texto Simples",
  rich_text: "Texto Formatado",
  create_new_answer_option: "Criar Nova Opção de Resposta",
  edit_answer_option: "Editar Opção de Resposta",
  relevant: "Relevante",
  irrelevant: "Irrelevante",
  enable_criteria: "Activar Critério",
  disable_criteria: "Desactivar Critério",
  set_criteria_as_relevant: "Definir critério como relevante",
  remove_criteria_as_relevant: "Remover critério como relevante",
  confirm_set_relevant: "Gostaria de definir este critério como relevante?",
  confirm_remove_relevant: "Gostaria de remover este critério como relevante?",
  relevant_criteria: "Critérios Relevantes",
  surname: "Apelido",
  role: "Função",
  create_user: "Criar Utilizador",
  edit_user: "Editar Utilizador",
  week: "Semana",
  sunday: "Domingo",
  monday: "Segunda-Feira",
  tuesday: "Terça-Feira",
  wednesday: "Quarta-Feira",
  thursday: "Quinta-Feira",
  friday: "Sexta-Feira",
  saturday: "Sábado",
  add_week: "Adicionar Semana",
  general_insights: "Percepções Gerais",
  resources_of_focus_insights: "Recursos de insights de foco",
  act_quiz_call_to_action: "Questionário de apelo à ação",
  general_criteria: "Critérios Gerais",
  self_criteria: "Critérios Próprios",
  professional_criteria: "Critérios Profissionais",
  social_criteria: "Critérios Sociais",
  report_and_react: "Reportar e reagir",
  heart_re_question: "Pergunta do Coração",
  highlight_schedule: "Agendamento",
  delete_week: "Apagar semana",
  next_question: "Pergunta Seguinte",
  previous_question: "Pergunta Anterior",
  done: "Submeter Questionário",
  answer_saved: "A resposta foi guardada",
  importar: "Importar",
  exportar: "Exportar",
  import_data: "Importar Dados",
  file_imported: "Ficheiro exportado",
  data_exported: "Dados exportados",
  error_exporting_data: "Erro ao exportar dados",
  invalid_questionnaire_email: "O email não está correto, por favor verifique novamente",
  page_not_found: "Página não encontrada",
  error_general: "Ocorreu um erro, por favor tente mais tarde",
  error_general_public:
    "Ocorreu um erro, por favor tente mais tarde ou contacte o apoio através de ",
  pay: "Pagar",
  payment: "Pagamento",
  payment_succeeded: "Pagamento efetuado com sucesso!",
  payment_unsuccessful:
    "O seu pagamento não foi bem sucedido. Por favor tente novamente.",
  payment_processing: "O seu pagamento está a ser processado.",
  pre_pay_invite: "Convite pré-pago",
  error: "Erro",
  export_data: "Exportar Dados",
  invitation: "Convite",
  disable_invitation: "Desactivar Convite",
  enable_invitation: "Activar Convite",
  algorithm_config: "Configuração do Algoritmo",
  user_evolution: "Evolução do Utilizador",
  no_data: "Sem Dados",
  answer_type: "Tipo de Resposta",
  import: "Importar",
  export: "Exportar",
  ADMIN: "Administrador",
  CONSULTANT: "Consultor",
  PRESCRIBER: "Prescritor",
  OWNER: "Proprietário",
  MANAGER: "Gestor",
  ASSISTANT: "Assistente",
  PACIENT: "Paciente",
  prescribers: "Prescritores",
  add_prescriber: "Adicionar/Modificar Prescritor",
  start_date: "Data Inicial",
  end_date: "Data Final",
  field_required: "Campo Obrigatório",
  report: "Relatório",
  type_to_search: "Escreva para pesquisar",
  summary_of_resources: "Resumo de recursos",
  sensorial_rhythms: "Ritmos Sensoriais",
  select_date: "Selecione uma data",
  confirm_invitation: "Tem a certeza que quer enviar este convite?",
  confirm_answer: "Tem a certeza que quer prosseguir?",
  confirm_prepayment: "Tem a certeza que quer pré-pagar este questionário?",
  free_invite: "Selecione esta opção para tornar o questionário gratuito",
  sending_email: "A enviar email...",
  to_fill_the_questionnaire: "para preencher o questionário",
  sending_invitation: "A enviar convite",
  invitation_sent: "Convite enviado",
  an_email_was_sent_to: "Um email foi enviado para",
  payment_page_title:
    "Analisar a sua Atividade Sensorial é essencial para cuidar da sua saúde",
  payment_page_list_title:
    "Ao fazer a análise da sua Atividade Sensorial está a possibilitar:",
  payment_page_list_item_one:
    "um tratamento ajustado à sua atividade fisiológica e biológica;",
  payment_page_list_item_two: "uma adaptação informada de recomendações e prescrições;",
  payment_page_list_item_three:
    "uma reactividade organicamente bem sucedida aos cuidados de saúde que necessitar",
  payment_taking_longer:
    "A transação está a demorar mais do que o esperado. Por favor aguarde enquanto a processamos ou volte mais tarde.",
  questionnaire_welcome_page_title: "Bem-vindo/a ao seu Sistema Sensorial",
  questionnaire_welcome_page_right_paragraph_one:
    "Tal como uma análise ao sangue, a análise SAYN irá demonstrar com exactidão o que o seu corpo evidentemente informa sobre si, mesmo que você não esteja consciente dessa informação.",
  questionnaire_welcome_page_right_paragraph_two:
    "Analisando os dados e correlações da sua orgânica biológica, será possível ao seu profissional de saúde perceber com clareza qual o cuidado, prescrição ou recomendação mais eficaz para si neste momento.",
  questionnaire_welcome_page_right_paragraph_three:
    "A análise da sua Atividade Sensorial será feita a partir de um questionário, cuja duração de preenchimento é de sensivelmente 15/20 minutos. No entanto, poderá levar o tempo que precisar. Para uma análise bem sucedida, é essencial que convoque este momento só para si.",
  questionnaire_welcome_page_right_list_title: "Antes de começar, o que deve saber:",
  questionnaire_welcome_page_right_list_item_one:
    "Responda de forma absolutamente livre e intuitiva, sem hesitar.",
  questionnaire_welcome_page_right_list_item_two:
    "O importante não é o que dizem ou já disseram sobre si, mas sim o que sente sobre si.",
  questionnaire_welcome_page_right_list_item_three:
    "Apele à sua franqueza e espontaneidade para promover uma leitura em perfeita sincronia com a sua orgânica. Não há respostas certas ou erradas.",
  questionnaire_welcome_page_right_list_item_four:
    "O questionário terá de ser preenchido na sua totalidade. Não poderá preencher uma parte agora e outra depois.",
  questionnaire_welcome_page_right_list_item_five:
    "Se hesitar numa resposta, não se preocupe. Recomenda-se que simplesmente passe à questão seguinte.",
  questionnaire_welcome_page_right_footnote:
    "Caso não queira avançar agora: Volte a clicar no link que recebeu por email para regressar mais tarde. Tem 30 dias para preencher o questionário, a contar da data de subscrição.",
  questionnaire_welcome_start_button_text: "Começar análise",
  questionnaire_completed_page_title: "A sua análise estará pronta em breve",
  questionnaire_completed_page_left_text:
    "E será enviada para o seu email, para que a partilhe com o seu profissional de saúde. Para mais informações sobre a primeira análise que descodifica o Sistema Sensorial em tempo real, consulte ",
  questionnaire_completed_page_right_text:
    "Recomende um cuidado em perfeito alinhamento com a verdadeira natureza de cada indivíduo, começando por quem mais gosta. Qualquer amigo ou familiar pode beneficiar desta análise para cuidar da sua saúde de forma personalizada.",
  questionnaire_completed_page_right_final: "Recomendar é cuidar.",
  questionnaire_completed_page_submitted_text:
    "Os seus dados foram submetidos com sucesso.",
  // BACKEND ERROR MESSAGES
  ACCESS_DENIED: "Acesso Negado",
  USER_DISABLED:
    "A sua conta foi suspensa por motivos internos. Contacte o proprietário da sua equipa caso considere que existe um problema.",
  OWNER_DISABLED:
    "A sua conta foi suspensa por motivos internos. Contacte-nos caso considere que existe um problema.",
  EMAIL_ALREADY_EXISTS: "Já existe um utilizador com este email",
  EMAIL_NOT_FOUND:
    "E-mail não encontrado. Por favor, verifique se inseriu corretamente o e-mail",
  USER_NOT_FOUND:
    "Utilizador não encontrado. \nPor verifique se o email está correto ou, em alternativa, peça o seu registo na plataforma.",
  INVITE_LINK_INVALID: "Este link já não é válido.",
  full_name: "Nome completo",
  team: "Equipa",
  company_team: "{name}",
  company_team_with_country: "{name}, {country}",
  company: "Empresa",
  companies: "Empresas",
  country: "País",
  owner: "Proprietário",
  practice_not_set_up:
    "A sua clínica/empresa ainda não está configurada. Aguarde até que o proprietário conclua o onboarding.",
  add_team_member: "Adicionar membro",
  edit_team_member: "Editar membro",
  suspend_member: "Suspender",
  unsuspend_member: "Reativar",
  remove_member: "Remover",
  suspend_member_confirm:
    "Suspender este membro da equipa? Não poderá iniciar sessão.",
  unsuspend_member_confirm:
    "Reativar este membro da equipa para que possa voltar a iniciar sessão?",
  remove_member_confirm:
    "Remover este membro da sua equipa? Perderá o acesso à plataforma.",
  no_team_members: "Ainda não existem membros na equipa.",
  team_member_invited: "Convite enviado.",
  change_member_role: "Alterar função",
  member_role_updated: "Função atualizada.",
  CANNOT_MANAGE_SELF: "Não pode alterar a sua própria função.",
  TEAM_MEMBER_CANNOT_BE_ADDED: "Este utilizador não pode ser adicionado.",
  USER_ALREADY_HAS_COMPANY:
    "Este utilizador já pertence a uma prática e não pode ser adicionado a outra.",
  view_member_insights: "Ver indicadores do membro",
  insights: "Indicadores",
  create_company: "Criar Empresa",
  edit_company: "Editar Empresa",
  owner_details: "Dados do proprietário",
  tie_existing_owner_title: "O utilizador já existe",
  tie_existing_owner_confirm:
    "Já existe um utilizador com este email. Pretende associá-lo a esta empresa como proprietário? A sua    função será alterada para Proprietário se necessário.",
  EXISTING_USER_AS_OWNER:
    "Já existe um utilizador com este email. Confirme para o associar como proprietário desta empresa.",
  tie_existing_staff_title: "O utilizador já existe",
  tie_existing_staff_confirm:
    "Já existe um utilizador com este email. Pretende alterar a função? A conta existente será mantida.",
  EXISTING_USER_AS_STAFF:
    "Já existe um utilizador com este email. Confirme para alterar a função.",
  USER_ALREADY_HAS_PRACTICE_ROLE:
    "Este utilizador já tem a função {role} noutra empresa.",
  no_owner: "(sem proprietário)",
  INVALID_COMPANY_OWNER: "O proprietário selecionado deve ter o papel de Proprietário.",
  MISSING_COMPANY_DETAILS: "As taxas da plataforma são obrigatórias para criar uma empresa.",
  MISSING_COMPANY: "Uma empresa é obrigatória para proprietários, gestores e prescritores.",
  CANNOT_EDIT_COMPANY_NAME_OR_OWNER:
    "O nome da empresa, o país e os dados do proprietário não podem ser alterados.",
  CANNOT_DELETE_OWNER_WITH_COMPANY:
    "Este utilizador não pode ser eliminado porque é proprietário de uma empresa. Elimine primeiro a empresa.",
  MISSING_COMPANY_OWNER:
    "O primeiro nome, apelido e email do proprietário são obrigatórios.",
  ADMIN_CANNOT_CREATE_PRESCRIBER:
    "Os administradores não podem criar prescritores. Crie um proprietário ou convide membros a partir da página da equipa.",
  ONLY_OWNER_CAN_EDIT_FEES: "Apenas o proprietário da clínica pode alterar as taxas.",
  INVALID_TEAM_ROLE: "Os membros da equipa devem ser convidados como Prescritor ou Gestor.",
  CANNOT_CREATE_ADMIN: "Não pode criar nem atribuir o papel de Administrador.",
  ASSISTANT_CANNOT_MANAGE_ADMIN:
    "Os assistentes não podem editar nem eliminar utilizadores administradores.",
  ACCESS_CONTEXT_ASSISTANT_ONLY:
    "As Permissões de Acesso só podem ser definidas para utilizadores Assistente.",
  access_context: "Permissões de Acesso",
  access_context_select_user: "Selecionar assistente",
  access_context_saved: "Permissões de Acesso guardadas.",
  access_context_module: "Módulo",
  access_action_read: "Ler",
  access_action_create: "Criar",
  access_action_update: "Atualizar",
  access_action_delete: "Eliminar",
  access_module_invitations: "Convites e Questionários",
  access_module_reports: "Relatórios",
  access_module_observations: "Observações",
  access_module_users: "Utilizadores",
  access_module_companies: "Empresas",
  access_module_report_templates: "Modelos de relatório",
  access_module_notification_templates: "Modelos de Notificações Push",
  access_module_email_templates: "Modelos de email",
  access_module_custom_texts: "Textos personalizados",
  access_module_editable_values: "Definições",
  access_module_editable_values_submenus: "Valores editáveis",
  access_module_database: "Base de dados",
  access_module_database_submenus:
    "Questionários, Perguntas, Opções de Resposta e Configuração de Texto",
  access_module_gallery: "Galeria",
  access_module_main_algorithm: "Algoritmo principal",
  access_module_main_algorithm_submenus:
    "Critérios, Utilização de critérios, Meta skills, Princípios, Configuração do algoritmo, Elementos",
  access_module_mobile_apps: "Aplicações móveis",
  access_module_mobile_apps_submenus:
    "Lista e por app: Componentes, Env, Utilizadores, Destaques, Histórico, Textos estáticos, Notificações, Critérios",
  access_module_advanced: "Avançado",
  access_module_advanced_submenus:
    "Sentimentos, Órgãos, Estações, Elementos naturais, Caracteres, Inputs, Outputs, Gestão de critérios",
  access_desc_invitations_read: "ver Histórico e Convites",
  access_desc_invitations_create: "convidar Utilizadores",
  access_desc_invitations_update: "alterar Respostas e Prescritor",
  access_desc_reports_update: "enviar ou bloquear envio",
  access_desc_users_update: "editar e suspender",
  access_desc_companies_update: "editar e suspender",
  access_desc_gallery_create: "carregar fotografias",
};

addLocaleData([...pt]);

export default messages;
